class Preferences {
  constructor() {
    this.locale = "en";
    this.uxData = {};
  }
}

// initial state
const state = () => (new Preferences());

// getters
const getters = {
  locale: state => {
    return state.locale
  },
  uxData: state => {
    return state.uxData!=null ? state.uxData : {}
  },
}

// actions
const actions = {

}

// mutations
const mutations = {
  locale: function(state , payload) {
    state.locale = payload
  },
  addUxData: function(state , payload) {
    state.uxData = {...state.uxData, ...payload}
  },
  resetUxData: function(state) {
    state.uxData = {}
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
